import { Unit } from 'models/Unit';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const UnitActionType = {
    FETCH_UNITS: 'FETCH_UNITS',
    FETCH_UNITS_SUCCESS: 'FETCH_UNITS_SUCCESS',
    ADD_UNIT: 'ADD_UNIT',
    ADD_UNIT_SUCCESS: 'ADD_UNIT_SUCCESS',
    EDIT_UNIT: 'EDIT_UNIT',
    EDIT_UNIT_SUCCESS: 'EDIT_UNIT_SUCCESS',
    DELETE_UNIT: 'DELETE_UNIT',
    DELETE_UNIT_SUCCESS: 'DELETE_UNIT_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchUnitsAction {
    type: typeof UnitActionType.FETCH_UNITS
    payload: ApiPayload,
    returnPayload: Unit[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddUnitsAction {
    type: typeof UnitActionType.ADD_UNIT
    payload: ApiPayload,
    returnPayload: Unit,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteUnitsAction {
    type: typeof UnitActionType.DELETE_UNIT
    payload: ApiPayload,
    returnPayload: Unit,
    meta: {
        isApiCall: boolean
    },
}

export type IUnitActions = IFetchUnitsAction | IAddUnitsAction | IDeleteUnitsAction

const baseUrl = 'api/units';
export class UnitActions {
    public static fetchUnits(token: string): IUnitActions {
        return {
            type: UnitActionType.FETCH_UNITS,
            payload: Api.fetchApiCall(baseUrl, token, UnitActionType.FETCH_UNITS_SUCCESS, UnitActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addUnit(token: string, unit: Unit): IUnitActions {
        return {
            type: UnitActionType.ADD_UNIT,
            payload: Api.postApiCall(baseUrl, token, UnitActionType.ADD_UNIT_SUCCESS, UnitActionType.API_ERROR, unit),
            returnPayload: Unit.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static editUnit(token: string, unit: Unit): IUnitActions {
        return {
            type: UnitActionType.EDIT_UNIT,
            payload: Api.putApiCall(baseUrl + '/' + unit.id, token, UnitActionType.EDIT_UNIT_SUCCESS, UnitActionType.API_ERROR, unit),
            returnPayload: Unit.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteUnit(token: string, id: number): IUnitActions {
        return {
            type: UnitActionType.DELETE_UNIT,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, UnitActionType.DELETE_UNIT_SUCCESS, UnitActionType.API_ERROR, true),
            returnPayload: Unit.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}